module.exports = __webpack_public_path__ + "static/media/ic_curtain_open.fbaa6bd2.png";